module.exports = __webpack_public_path__ + "img/checklist.66781fdb.svg";